/**
 * Кастомный класс ошибки для API запросов
 */
export class ApiError extends Error {
    constructor(message, options) {
        super(message);
        this.name = 'ApiError';
        this.statusCode = options?.statusCode;
        this.originalError = options?.originalError;
        this.context = options?.context;
        // Восстанавливаем stack trace
        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, ApiError);
        }
    }
}
